//utils
import serializeObject from "../../../utils/SerializeObject";

import request from "../base-request";

export const fetchEasyAddReviews = async (employeeID: string, subjectID: string, query: any) => {
	try {
		const [data] = await request<{ reviews: string[]; total_count: number }>(
			`/api/reviews/easy-add/${employeeID}/${subjectID}/?${serializeObject(query)}`
		);
		return data;
	} catch (error) {
		throw error;
	}
};
